import { VIP_TYPE } from '@/constants'

const CYCLE_DAYS: Record<number, number> = {
  6: 1, // OneDay
  7: 3, // ThreeDays
  1: 7, // WEEK
  2: 30, // MONTH
  3: 90, // SEASON
  4: 183, // HALF_YEAR
  5: 365, // YEAR
}

export function shouldShowDailyPrice(item: any, isZero: (v: any) => boolean): boolean {
  if (!item || item.subscribeType === VIP_TYPE.DISCOUNT)
    return false
  if (!item.preferentialPrice || isZero(item.preferentialPrice))
    return false
  const p = Number(item.preferentialPrice)
  const o = Number(item.price)
  if (!o || !p || p >= o)
    return false
  if (!CYCLE_DAYS[item.cycle])
    return false
  return true
}

export function getDailyPrice(item: any): string {
  const days = CYCLE_DAYS[item.cycle] || 1
  return (Number(item.preferentialPrice) / days).toFixed(2)
}

/**
 * 无优惠价档位的「每日单价」数值（仅数字，不含 / Day 后缀）。
 * 与 useSubscription.getUnitPrice 取值一致，但拆出后缀以便统一渲染样式。
 * 单日及未知周期返回 ''（不展示日单价）。
 */
export function getUnitPriceValue(item: any): string {
  const days = CYCLE_DAYS[item?.cycle]
  if (!days || days <= 1)
    return ''
  return (Number(item.price) / days).toFixed(2)
}

/**
 * 划线价旁是否展示优惠总价：单日会员的优惠总价与上方「/ Day」单价数值相同，
 * 重复展示故隐藏；多日周期（周/月等）总价与日单价不同，保持展示。
 */
export function shouldShowPreferentialTotal(item: any, isZero: (v: any) => boolean): boolean {
  if (!shouldShowDailyPrice(item, isZero))
    return false
  return (CYCLE_DAYS[item.cycle] || 1) > 1
}

export function getSavePercent(item: any): number {
  const p = Number(item.preferentialPrice)
  const o = Number(item.price)
  if (!o || !p || p >= o)
    return 0
  return Math.round((1 - p / o) * 100)
}
